const planCodes = [
  {
    MaxAgeYears: '76',
    MinAgeYears: '35',
    PlanCode_ID: '1_2_NM_9ohhZe',
    PlancodeDescription: 'Ordinary Life',
    PlanCodeNumber: '312',
    excludesProducts: [
      {
        productId: '2',
        planCodeId: '1_2_NM_vQUcrR'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS263'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS262'
      }
    ],
    displayOrder: 1
  },
  {
    MaxAgeYears: '55',
    MinAgeDays: '30',
    PlanCode_ID: '1_2_NM_vQUcrR',
    PlancodeDescription: 'Ordinary Life Paid Up At 65',
    PlanCodeNumber: '313',
    excludesProducts: [
      {
        productId: '2',
        planCodeId: '1_2_NM_9ohhZe'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS262'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS263'
      }
    ],

    displayOrder: 2
  },
  // {
  //   MaxAgeYears: '68',
  //   MinAgeDays: '18',
  //   PlanCode_ID: '1_1_NM_x3uIvr',
  //   PlancodeDescription: '$3,000 Accidental Death Policy',
  //   Description:
  //     'The ADP can cover both you and your spouse with $3,000 of coverage each, and $1,000 of coverage for each child in your home. Take advantage of the $3,000 ADP and you will pay no premiums during the first policy year. At the end of the first policy year, keep the coverage for a $10 premium. If you decide not to pay the premium, the plan will terminate and no premiums will be due.',
  //   PlanCodeNumber: 'FE5',
  //   noRates: true,
  //   displayOrder: 5,
  //   type: 'ADP',
  //   eligibility: {
  //     employee: {
  //       condition: 'allowed'
  //     },
  //     spouse: {
  //       condition: 'allowed'
  //     },
  //     child: {
  //       condition: 'na'
  //     }
  //   },
  //   requirements: {
  //     employee: {
  //       condition: 'exclude',
  //       excludedBy: ['spouse'],
  //       age_child: {
  //         minAgeDays: 0,
  //         maxAgeYears: 20
  //       }
  //     },
  //     spouse: {
  //       condition: 'exclude',
  //       excludedBy: ['employee', 'applicant'],
  //       age_child: {
  //         minAgeDays: 0,
  //         maxAgeYears: 20
  //       }
  //     },
  //     child: {
  //       condition: 'na'
  //     }
  //   },
  //   specialPremium: 0,
  //   specialPremiumNote: '(for the first year, $10 a year thereafter)',
  //   specialFaceAmount: '$3,000 each employee/spouse',
  //   specialFaceAmountLineTwo: '$1,000 per eligible child'
  // },
  {
    MaxAgeYears: '71',
    MinAgeYears: '54',
    PlanCode_ID: '4_3_NM_8kS262',
    PlancodeDescription: 'Term to 100 Life',
    PlanCodeNumber: '262',
    excludesProducts: [
      {
        productId: '2',
        planCodeId: '1_2_NM_vQUcrR'
      },
      {
        productId: '2',
        planCodeId: '1_2_NM_9ohhZe'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS263'
      }
    ],
    displayOrder: 4
  },
  {
    MaxAgeYears: '55',
    MinAgeYears: '0',
    PlanCode_ID: '4_3_NM_8kS263',
    PlancodeDescription: 'Term Life',
    PlanCodeNumber: '263',
    excludesProducts: [
      {
        productId: '2',
        planCodeId: '1_2_NM_vQUcrR'
      },
      {
        productId: '2',
        planCodeId: '1_2_NM_9ohhZe'
      },
      {
        productId: '3',
        planCodeId: '4_3_NM_8kS262'
      }
    ],
    displayOrder: 3
  }
]
export default planCodes

/*
ADP from dynamo
{
  "Description": "The ADP can cover both you and your spouse with $3,000 of coverage each, and $1,000 of coverage for each child in your home. Take advantage of the $3,000 ADP and you will pay no premiums during the first policy year. At the end of the first policy year, keep the coverage for a $10 premium. If you decide not to pay the premium, the plan will terminate and no premiums will be due.",
  "displayOrder": 5,
  "eligibility": {
    "child": {
      "condition": "na"
    },
    "employee": {
      "condition": "allowed"
    },
    "spouse": {
      "condition": "allowed"
    }
  },
  "MaxAgeYears": "68",
  "MinAgeDays": "18",
  "noRates": true,
  "PlanCode_ID": "1_1_NM_x3uIvr",
  "PlancodeDescription": "$3,000 Accidental Death Policy",
  "PlanCodeNumber": "FE5",
  "requirements": {
    "child": {
      "condition": "na"
    },
    "employee": {
      "age_child": {
        "maxAgeYears": 20,
        "minAgeDays": 0
      },
      "condition": "exclude",
      "excludedBy": [
        "spouse"
      ]
    },
    "spouse": {
      "age_child": {
        "maxAgeYears": 20,
        "minAgeDays": 0
      },
      "condition": "exclude",
      "excludedBy": [
        "employee",
        "applicant"
      ]
    }
  },
  "specialFaceAmount": "$3,000 each employee/spouse",
  "specialFaceAmountLineTwo": "$1,000 per eligible child",
  "specialPremium": 0,
  "specialPremiumNote": "(for the first year, $10 a year thereafter)",
  "type": "ADP"
}

*/
/*
from dynamo
{
  "displayOrder": 4,
  "excludesProducts": [
    {
      "planCodeId": "1_2_NM_vQUcrR",
      "productId": "2"
    },
    {
      "planCodeId": "1_2_NM_9ohhZe",
      "productId": "2"
    },
    {
      "planCodeId": "4_3_NM_8kS263",
      "productId": "3"
    }
  ],
  "MaxAgeYears": "71",
  "MinAgeYears": "54",
  "PlanCode_ID": "4_3_NM_8kS262",
  "PlancodeDescription": "Term to 100 Life",
  "PlanCodeNumber": "262"
}
*/
/*
{
  "displayOrder": 3,
  "excludesProducts": [
    {
      "planCodeId": "1_2_NM_vQUcrR",
      "productId": "2"
    },
    {
      "planCodeId": "1_2_NM_9ohhZe",
      "productId": "2"
    },
    {
      "planCodeId": "4_3_NM_8kS262",
      "productId": "3"
    }
  ],
  "MaxAgeYears": "55",
  "MinAgeYears": "0",
  "PlanCode_ID": "4_3_NM_8kS263",
  "PlancodeDescription": "Term Life",
  "PlanCodeNumber": "263"
}
*/
